export const currentEndeavors = [
    {
        header: `CHANI APP`,
        content: `Combining the wisdom of the stars with mindfulness and meditation, CHANI supports your growth and well-being by providing the most detailed birth chart and transit explanations available.`,
        date: `March 2022 — Present`,
        linkText: `launch application`,
        link: `https://chaninicholas.com/chani-app/`
    },
    {
        header: `[ REDACTED ].COM`,
        content: `A dynamic art portfolio website and online store, featuring my personal work. Previously built with Wix/Velo, and currently being remade with Next.js. Constantly growing and changing in terms of content and functionality.`,
        date: `2018 — Present`,
        linkText: `if you know, you know`,
        link: ``,
    },
    {
        header: `BAITES.DEV`,
        content: `This static, one-paged, little baby features a fully responsive && playful design (by me) to showcase personality and frontend development skills. Varying presentations for desktop, tablet, and mobile. Built with React.js, Hooks, Styled Components, and pure CSS animations.`,
        date: `October 2020`,
        linkText: `you're already here`,
        link: ``
    },
];